<template>
  <div v-if="emplacement">
    <div class="card mgt-20px">
      <header class="header-card">
        <p>
          {{ $t('clientEmplacement.caracteristique') }}
        </p>
      </header>
      <div class="card-content">
        <header-emplacement class="mgt-20px mgb-20px" :emplacement="emplacement">
          <div class="column is-12">
            <b-field :label="$t('clientEmplacement.client')" class="obligatoire">
              <b-autocomplete
                @input="getAsyncClientsData"
                @select="setClient"
                :value="searchClient"
                :data="dataClients"
                :loading="isFetchingClient"
                field="nomCommercial"
                icon="magnify">
                <template slot-scope="props">
                  {{ props.option.nomCommercialAvecVille }}
                </template>
                <template slot="empty">
                  {{$t(`general.autocomplete.${!isFetchingClient ? 'noRslt' : 'search'}`)}}
                </template>
              </b-autocomplete>
            </b-field>
          </div>
        </header-emplacement>
      </div>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>
          {{ $t('adresseEmplacement.adresse') }}
        </p>
      </header>
      <div class="card-content">
        <adresse-emplacement :adresseCadastraleInformation="emplacement.adresseCadastrale"
                             :showTitle="false">
        </adresse-emplacement>
      </div>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>
          {{ $t('clientEmplacement.pj') }}
        </p>
      </header>
      <div class="card-content">
        <app-pieces-jointes deletable :checkPermissions="checkPermissions(permEmplacement.maj)">
        </app-pieces-jointes>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import debounce from 'lodash/debounce';
import { EMPLACEMENT } from '@/configuration/gabed/permissionsGabedConf';
import headerEmplacement from '@/components/gabed/emplacement/headerCreationEmplacement';
import adresseEmplacement from '@/components/gabed/emplacement/adresseCreationEmplacement';
import PiecesJointes from '@/components/general/piecesJointes';
import { getAllByTradeName } from '@/api/tiers/index';
import { TIERS_TYPE_CLIENT, TIERS_SOUS_TYPE_AUCUN } from '@/configuration/tiers/tiersConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import messageErreur from '@/services/general/messageErreur';
import cloneDeep from 'lodash/cloneDeep';

const permissions = createNamespacedHelpers('permissions');
const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    emplacement: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      permEmplacement: EMPLACEMENT,
      isFetchingClient: false,
      searchClient: '',
      dataClients: [],
    };
  },
  components: {
    headerEmplacement,
    adresseEmplacement,
    appPiecesJointes: PiecesJointes,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    getAsyncClientsData: debounce(async function loadData(text) {
      if (text === this.searchClient) return;
      this.isFetchingClient = true;
      this.searchClient = text;
      this.emplacement.clientId = null;
      this.emplacement.client = null;
      try {
        const tiers = (await getAllByTradeName(
          text, this.societeActiveId,
          TIERS_TYPE_CLIENT, [TIERS_SOUS_TYPE_AUCUN],
        )).data.result.items;
        tiers.forEach(this.formatTiers);
        this.dataClients = tiers;
        this.isFetchingClient = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetchingClient = false;
        throw (e);
      }
    }, 500),
    formatTiers(tiers) {
      const wordsList = [
        tiers.code, tiers.nomCommercial,
        adressFullStringGetter(tiers.adressePostale, false),
        tiers.compteComptable];
      tiers.nomCommercialAvecVille = wordsList.filter(w => !!w).join(' - ');
    },
    setClient(item) {
      if (!item) return;
      this.searchClient = item.nomCommercial;
      this.emplacement.clientId = item.id;
      this.emplacement.client = item;
      if (!this.emplacement.libelle?.trim()) this.emplacement.libelle = item.nomCommercial;
      this.emplacement.adresseCadastrale = cloneDeep(item.adressePostale);
    },
  },
  mounted() {
    if (this.emplacement.client) {
      this.formatTiers(this.emplacement.client);
      this.searchClient = this.emplacement.client.nomCommercial;
    }
  },
};
</script>
